var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 0.75H1.40625C0.615234 0.75 0 1.39453 0 2.15625V10.5938C0 11.3848 0.615234 12 1.40625 12H13.5938C14.3555 12 15 11.3848 15 10.5938V2.15625C15 1.39453 14.3555 0.75 13.5938 0.75ZM13.5938 2.15625V3.35742C12.9199 3.91406 11.8652 4.73438 9.63867 6.49219C9.14062 6.87305 8.17383 7.81055 7.5 7.78125C6.79688 7.81055 5.83008 6.87305 5.33203 6.49219C3.10547 4.73438 2.05078 3.91406 1.40625 3.35742V2.15625H13.5938ZM1.40625 10.5938V5.17383C2.05078 5.70117 3.01758 6.46289 4.45312 7.60547C5.09766 8.10352 6.24023 9.2168 7.5 9.1875C8.73047 9.2168 9.84375 8.10352 10.5176 7.60547C11.9531 6.46289 12.9199 5.70117 13.5938 5.17383V10.5938H1.40625Z",
    fill: "#1F4760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3bb40f20dab81fd0f05d71f6dde9d9dd.svg";
export { ForwardRef as ReactComponent };